import { ConfigurableProductOptions } from '~/modules/GraphQL/types';
import { Dictionary } from 'vue-router/types/router';

function toTitleCase(str: string) {
  return str.toLowerCase().replace(/(?:^|[\s-/])\w/g, function(match) {
    return match.toUpperCase();
  });
}

function getSortedAttributes(attributes: ConfigurableProductOptions[]): ConfigurableProductOptions[] {
  return attributes?.sort((a, b) => a.position - b.position);
}

export function parseConfigurationFromHash(hash: string, configurableOptions: ConfigurableProductOptions[]): Dictionary<string | (string | null)[]> {
  if (!hash || !configurableOptions) {
    return {};
  }
  if (hash.startsWith('#')) {
    hash = hash.slice(1);
    if (!hash.length) {
      return {};
    }
  }
  hash = decodeURIComponent(hash);
  const values = hash.split('-');
  const configuration = {};
  configurableOptions = getSortedAttributes(configurableOptions);
  for (let i = 0; i < values.length; i++) {
    let formattedValue = toTitleCase(values[i].replace(new RegExp('_','g'), ' '));
    formattedValue = formattedValue.replace(new RegExp("Xl","g"), 'XL');
    const attribute = configurableOptions[i];
    if (attribute.attribute_code === 'att_height_options') {
      formattedValue += '"';
    }
    const value = attribute.values.find(value => value.label === formattedValue);
    if (value) {
      configuration[attribute.attribute_uid] = value.uid;
    }
  }
  return configuration;
}

export function buildHash(configuration: Dictionary<string | (string | null)[]>, configurableOptions: ConfigurableProductOptions[]) {
  const valueLabels = [];
  getSortedAttributes(configurableOptions).forEach(attribute => {
    if (configuration[attribute.attribute_uid]) {
      const value = attribute.values.find(v => v.uid === configuration[attribute.attribute_uid]);
      if (attribute.attribute_code === 'att_height_options') {
        const label = value?.label?.replace(/"/g, '');
        valueLabels.push(label || '');
      } else {
        valueLabels.push(value?.label || '');
      }
    } else {
      valueLabels.push('');
    }
  });
  return valueLabels.join('-').replace(/ /g, '_').toLowerCase();
}
